module.exports = window.dnn.nodeModules.Moment;